// Side-effect module, imported FIRST in index.js: the reporter must be
// wrapping the console before firebase.js evaluates, because firebase.js logs
// which auth persistence the page chose (`[Firebase] iOS WebView detected …`)
// at import time — and a page that picked a store without the session is one
// way the in-app handover lands signed out. The transport is imported lazily
// for the same reason: importing firebaseFunctions here would evaluate
// firebase.js before the reporter exists.
import { installHostIssueReporter } from './hostIssueReporter';

installHostIssueReporter({
  send: (payload) =>
    import('../../firebaseFunctions').then(({ createCallable }) =>
      createCallable('reportClientIssue')(payload)
    ),
});
